import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Unstable_Grid2';
import TextField from '@mui/material/TextField';

import '../../style/SignupForm.css';

const FormTextField = ({ id, name, label, required, type, inputProps, errors, onChange, onBlur, placeholder, FormHelperTextProps = undefined }) => {
  const { t } = useTranslation();

  return (
    <Grid xs={12} sm={12} md={6} lg={6} className="form-input">
      <TextField
        id={id}
        required={required}
        fullWidth
        size="small"
        name={name}
        label={t(label) || ''}
        type={type}
        inputProps={inputProps}
        onChange={onChange}
        onBlur={onBlur}
        error={Boolean(errors)}
        helperText={errors || ''}
        placeholder={placeholder || ''}
        FormHelperTextProps={FormHelperTextProps}
      />
    </Grid>
  );
};

export default FormTextField;